<!-- <button  mat-fab [color]="color" (click)="buttonClicked()" [ngClass]="position" [disabled]="disabled" >
  <mat-icon>{{ icon }}</mat-icon>
</button> -->
<button mat-fab [color]="color" (click)="buttonClicked()" [disabled]="disabled">
  <mat-icon>{{ icon }}</mat-icon>
</button>
